"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Option = void 0;
class Option {
    constructor(data) {
        this.id = data.id;
        this.text = data.text;
        this.target = data.target;
        this.condition = data.condition;
        this.effect = data.effect;
        this.waitMessage = data.waitMessage;
        this.autoTransition = data.autoTransition;
        this.isBackOption = data.isBackOption;
    }
    hasCondition() {
        return !!this.condition;
    }
    hasEffect() {
        return !!this.effect;
    }
    hasWaitMessage() {
        return !!this.waitMessage;
    }
    hasAutoTransition() {
        return !!this.autoTransition;
    }
    hasBackOption() {
        return !!this.isBackOption;
    }
    toJSON() {
        return {
            id: this.id,
            text: this.text,
            target: this.target,
            condition: this.condition,
            effect: this.effect,
            waitMessage: this.waitMessage,
            autoTransition: this.autoTransition,
            ...(this.isBackOption ? { isBackOption: true } : {})
        };
    }
}
exports.Option = Option;
//# sourceMappingURL=Option.js.map